import { of, BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as Papi from '@app/papi';

import * as Rest from '../rest'; 

// Environment
import { environment } from '../../environments/environment';

@Injectable()
export class Service extends Rest.Service {
	constructor(httpClient: HttpClient, papi: Papi.Service) {
        super(httpClient, papi);
    }

    public get basepath(): string {
        return environment.PULSE_BASE_PATH;
    }
}
